import { Trans } from '@lingui/macro';
import {css} from 'styled-components';
import React from "react";

export const EditableStyled = css`
  /* stylelint-disable no-descending-specificity */

  .editable-table {
    background-color: #fafafa;

    .ant-table-content {}

    tr, td.ant-table-cell {}

    .ant-table .ant-table-tbody > tr:not(.ant-table-measure-row) > td {
      position: relative;
      height: 42px;
      padding: 8px;
      line-height: 24px;
      vertical-align: top;

      .ant-row.ant-form-item, .ant-row.ant-legacy-form-item {
        min-height: 24px;
        margin-top: 0;
      }
    }

    tr.selected, tr.selected > td, tr.selected:hover, tr.selected:hover > td {
      background: #e6f7ff !important;
    }

    tr.error, tr.error > td, tr.error:hover, tr.error:hover > td {
      /* background: #faeceb !important; */
    }

    tr.linked, tr.linked > td, tr.linked:hover, tr.linked:hover > td {
      background: #f6ffed !important;
    }

    /* bundle-item rows */
    tr.bundle-item, tr.bundle-item > td {
      background: #f5feff;
    }

    tr.bundle-item:not(.selected):hover, tr.bundle-item:not(.selected):hover > td {
      background: #e8fbff !important;
    }

    /* bundle-discount rows */
    tr.bundle-discount, tr.bundle-discount > td {
      background: #fffef5;
    }

    tr.bundle-discount:not(.selected):hover, tr.bundle-discount:not(.selected):hover > td {
      background: #fffbdc !important;
    }

    tr.bundle-item, tr.bundle-discount{
      .ant-table-cell.drag-visible {
        border-left: 4px solid #1FB6C6;
      }
    }

    td.with-error, .with-error {
      color: #f5222d;
    }

    td.with-error-2 .container, .with-error-2 .container, .container.with-error2 {
        display: flex;
        width: 100%;
        color: red;

        .error-icon {
          display: flex;
          align-items: center
        }

        .error-text {
          flex: 1 1 0;
          min-width: 0;
          max-width: calc(100% - 16px);
        }

        .clear-icon {
          display: flex;
          flex: 0 0 12px;
          align-items: center;
          font-size: 12px;
          color: rgba(0, 0, 0, 25%);
          transition: color 0.3s ease;

          &:hover {
            color: rgba(0, 0, 0, 45%);
          }
        }
    }

    &.transaction-transfer-table {
      tr.ant-table-row-selected,
      tr.ant-table-row-selected > td,
      tr.ant-table-row-selected:hover,
      tr.ant-table-row-selected:hover > td {
        background: #f6ffed !important;
      }

      .ant-checkbox-wrapper:hover .ant-checkbox-inner,
      .ant-checkbox:hover .ant-checkbox-inner,
      .ant-checkbox-input:focus + .ant-checkbox-inner {
        border-color: #389e0d;
      }

      .ant-checkbox-checked .ant-checkbox-inner {
        background: #237804;
        border-color: #237804;
      }

      .ant-checkbox-indeterminate .ant-checkbox-inner::after {
        background: #389e0d;
      }

      .ant-checkbox-checked::after {
        border-color: #389e0d;
      }

      .right-info-container {
        position: absolute;
        top: 50%;
        left: 100%;
        z-index: 1000;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        transform: translateY(-50%);
      }

      .subscription-lock-icon {
        margin-left: unset;
      }
    }

    .ant-legacy-form-item, .ant-form-item {
      margin: 0;

      .product-id-select {
        margin-bottom: 8px;
      }

      .account-id-select {
        width: 102px;
      }

      .tax-code-id-select {
        width: 87px;
      }

      .quantity-input {
        margin-bottom: 4px;
        text-align: right;
      }

      .location-tag {
        max-width: 100%;
        margin-right: 0;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      /* Done */
      .ant-legacy-form-item-control, .ant-form-item-control {
        min-height: 22px;
        line-height: 24px;

        .ant-form-item-control-input {
          min-height: 24px;

          .ant-input-affix-wrapper {
            height: 24px;
            padding: 0;
            line-height: 24px;
            background: inherit;
            border: 0;
            border-bottom: 1px solid rgba(0, 0, 0, 20%);
            border-radius: 0;
            box-shadow: none !important;

            input {
              border: 0 !important;
            }

            &.currency {
              input {
                text-align: right;
              }
            }
          }

          .ant-input-affix-wrapper-focused {
            /* background: #e6f7ff !important; */
            background: transparent !important;
          }
        }

        input {
          height: auto;
          padding: 0;
          line-height: 24px;
          background: transparent !important;
          border: 0;
          border-bottom: 1px solid rgba(0, 0, 0, 20%);
          border-radius: 0;
          box-shadow: none !important;

          &:focus {
            background: transparent !important;
          }

          &.unit-price-input,
          &.amount-input,
          &.discount-input,
          &.balance-input {
            height: 24px;
            text-align: right;
          }

          &.ant-input-disabled {
            border-bottom: 1px solid transparent !important;
          }
        }

        .ant-select {
          height: 24px;
          border-bottom: 1px solid rgba(0, 0, 0, 20%);
          border-radius: 0;

          input {
            border: 0 !important;
          }

          &.ant-select-multiple {
            .ant-select-selector {
              height: 24px;

              .ant-select-selection-search input {
                margin-left: 0;
              }

              .ant-select-selection-placeholder {
                right: 18px;
                left: 0;
              }

              .ant-select-selection-item {
                height: 22px;
                margin-top: 0;
                margin-bottom: 2px;
              }
            }
          }

          .ant-select-selector {
            height: auto;
            padding: 0;
            background: inherit;
            border: 0;
            box-shadow: none !important;

            &:focus {
              /* background: #e6f7ff; */
              background: transparent !important;
            }

            &::after {
              line-height: 21px;
            }

            .ant-select-selection-search {
              right: 18px;
              left: 0;

              input {
                height: 22px;
              }
            }

            .ant-select-selection-placeholder,
            .ant-select-selection-item {
              line-height: 22px;

              .select-children-item {
                padding-left: 0;
              }
            }
          }

          .ant-select-arrow,
          .ant-select-clear {
            top: unset;
            right: 3px;
            bottom: 6px;
          }

          &.ant-select-auto-complete .ant-select-selector::after {
            /* background: rgba(0,0,0,5%); */
            line-height: 22px;
          }
        }

        .ant-picker {
          height: auto;
          padding: 0;
          background: inherit;
          border: 0;
          border-bottom: 1px solid rgba(0, 0, 0, 20%);
          border-radius: 0;
          box-shadow: none !important;

          &.ant-picker-disabled {
            border-bottom: 1px solid transparent;
          }

          .ant-picker-input {
            input {
              border: 0 !important;
            }
          }
        }

        .ant-input-group-wrapper {
          height: 24px;
          padding: 0 !important;

          .ant-input-group {
            height: 25px;
            border-bottom: 1px solid rgba(0, 0, 0, 20%);
            border-radius: 0;

            .ant-input-group-addon {
              padding: 0;
              text-align: left;
              background: inherit;
              border: 0;

              .ant-select {
                /* 24px - 1px */
                height: 23px;  
              }
            }

            input {
              right: 0.5px;
              height: 24px;
              padding-left: 0;
              background: inherit;
              border: 0 !important;

              /* top: -1px; */
            }

            .ant-select {
              margin: 0;
              border: none !important;
            }
          }
        }

        textarea.ant-input {
          height: 21px;
          min-height: 21px;

          /* max-height: 47px; */
          padding: 0;
          margin-bottom: 0 !important;
          line-height: 23px;
          resize: none;
          background: inherit;
          border: 0;
          border-bottom: 1px solid rgba(0, 0, 0, 20%);
          border-radius: 0;
          box-shadow: none !important;

          &:focus {
            /* background: #e6f7ff !important; */
            background: transparent !important;
          }
        }
      }


    }

    .ant-select-selection {
      height: auto;
      background: inherit;
      border: 0;
      box-shadow: none !important;

      &:focus {
        /* background: #ffd8bf; */
        background: transparent !important;
      }

      .ant-select-selection__rendered {
        margin-right: 18px;
        margin-left: 0;
        line-height: 21px;
      }

      .ant-select-arrow,
      .ant-select-selection__clear {
        right: 3px;
      }
    }

    .ant-input-number {
      background: transparent !important;
      border: 0;
      box-shadow: none !important;
    }

    .ant-calendar-picker-clear,
    .ant-calendar-picker-icon {
      right: 3px;
    }

    .switch-locked.ant-switch-checked {
      background: #333;
    }

    /* All the styling of normal divs (not editable) */
    .product-id {
      margin-bottom: 8px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .service-date {
      margin-top: 8px;
      margin-bottom: 1px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;

      b.subheading {
        margin-right: 4px;
        font-weight: 500;
      }

      &.form-item {
        display: flex;
        flex-flow: row nowrap;
        margin-bottom: 0;

        .ant-row.ant-form-item {
          flex: 1;
          min-width: 0;
        }
      }
    }

    .multiline {
      min-height: 24px;
      padding-right: 16px;
      overflow: auto;
      line-height: 23px;
      white-space: pre-wrap;
      border-bottom: 1px solid transparent;

      &.multiline-3 {
        display: -webkit-box;
        max-height: 71px;
        overflow: hidden;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3;
      }

      &.multiline-6 {
        display: -webkit-box;
        max-height: 139px;
        overflow: hidden;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 6;
      }

      &.bold {
        font-weight: 500;
      }
    }

    .amount-container {
      display: flex;
      width: 100%;
      line-height: 24px;

      .currency {}

      .value {
        flex: 1 1 0;
        text-align: right;
      }
    }

    .locked {
      color: #a4a4a4;
      user-select: none;
      background: #f8f8f8;
    }

    .asterisk {
      color: #f5222d;
    }

    .ant-select-arrow {
      .subscription-lock-icon {
        font-size: 14px;
      }
    }

    .ant-select-selection-placeholder {
      text-align: left;
    }

    .ant-select-disabled.ant-select {
      /* border-bottom: 1px solid rgba(255, 163, 158, 40%) !important; */
    }
  }

  .location-select-form-item {
    .ant-select-selection-item {
      display: flex;
      text-align: left;

      .text {
        flex: 1;
        min-width: 0;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;

        .name {
          font-weight: 400;
        }
      }

      .balance {
        display: none;
      }
    }
  }

  .batch-asset-table {
    th.ant-table-cell {
      border-top: 1px solid #f0f0f0
    }
  }
`;

export const RequiredTd = <span className="with-error">(Required)</span>;

export function RequiredSpan(overrideText = '') {
    return (
        <span style={{color: '#f5222d'}}>
            (
            {overrideText || <Trans>Required</Trans>}
            )
        </span>
    );
}

export function RequiredSpanTd({overrideText, style, ...restProps}) {
    return (
        <span {...restProps} style={{...style, color: '#f5222d'}}>
            (
            {overrideText || <Trans>Required</Trans>}
            )
        </span>
    );
}
